import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Departments from '../components/Departments';
import About from '../components/About';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Hero />
      <About />
      <Departments />
    </div>
  );
};

export default Home;